<template>
    <div class="loader-overlay" v-if="$store.getters['loadingScreen/getLoading']">
        <div class="loader-content" >
            <div class="borda-1"></div>
            <div class="borda-2"></div>
            <div class="logo-empresa">
                <img src="/img/logo/ugt_logo.png" alt="UGT-SP" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'loading',
    }
</script>

<style lang="scss" scoped>
    .loader-overlay {
        @apply .fixed .flex .flex-col .w-screen .h-screen .top-0 .bottom-0 .left-0 .right-0 .items-center .justify-center .z-50;
        background-color: rgb(0 0 0 / 50%);

        .loader-content {
            @apply flex items-center justify-center bg-transparent;

            .borda-1 {
                border: 5px solid transparent;
                border-radius: 50%;
                border-top: 5px solid #e6242c;
                width: 200px;
                height: 200px;
                -webkit-animation: spin 2s linear infinite; /* Safari */
                animation: spin 2s linear infinite;
                animation-name: border-1;
                position: absolute;

                @-webkit-keyframes border-1 {
                    from { -webkit-transform: rotate(360deg); }
                    to { -webkit-transform: rotate(0deg); }
                }

                @keyframes border-1 {
                    from { -webkit-transform: rotate(360deg); }
                    to { -webkit-transform: rotate(0deg); }
                }
            }

            .borda-2 {
                border: 5px solid transparent;
                border-radius: 50%;
                border-top: 5px solid #fff200;
                width: 180px;
                height: 180px;
                -webkit-animation: spin 2s linear infinite; /* Safari */
                animation: spin 2s linear infinite;
                animation-name: border-2;
                position: absolute;

                @-webkit-keyframes border-2 {
                    from { -webkit-transform: rotate(0deg); }
                    to { -webkit-transform: rotate(360deg); }
                }

                @keyframes border-2 {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            }

            .logo-empresa {
                @apply absolute;

                img {
                    width: 100px;
                }
            }
        };
    }
</style>
